import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MxAlertService, MxBaseRestService } from 'mx-commons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseNotificationPopup } from 'src/app/model/notificationPopUp';
import { ProfileUser } from 'src/app/model/user';
import { isNullOrUndefined } from 'src/app/shared/helpers/utils';
import { StatusResultModalEdit } from 'src/app/shared/services/modal.service';
import { SaveService } from 'src/app/shared/services/save.service';

@Component({
	selector: 'app-notificacao',
	templateUrl: './notificacao.component.html',
	styleUrls: ['./notificacao.component.scss']
})
export class ModalNotificationListComponent implements OnInit {

	data: BaseNotificationPopup = null;
	formGroup: FormGroup;
	profilesAll: Array<NotificationProfiles> = [];
	isSelect: Array<boolean>;
	success: (resultData: BaseNotificationPopup, status: StatusResultModalEdit) => void;

	constructor(private readonly bsModalRef: BsModalRef,
		private readonly formBuilder: FormBuilder,
		private readonly saveService: SaveService,
		private readonly alertService: MxAlertService,
		private readonly authService: SaveService,
		private readonly restService: MxBaseRestService) {
	}

	async ngOnInit(): Promise<void> {
		if (isNullOrUndefined(this.data)) {
			this.data = new BaseNotificationPopup();
		}
		await this.loadProfilesAll();
		this.createForm();

		console.log('notification modal => ', this.data)
	}

	// ngAfterContentChecked(): void {
	// 	this.isSelect = this.profilesAll.map(pa => this.data.profiles.find(p => p === pa.id) ? true : false);
	// }

	private createForm(): void {
		this.formGroup = this.formBuilder.group(
			{
				title: [
					{ value: this.data.title, disabled: this.data.id !== null },
				],
				body: [
					{ value: this.data.body, disabled: this.data.id !== null },
				],
				profiles: [
					{ value: this.data.profiles, disable: this.data.id !== null }
				],
			}
		);
	}

	private async loadProfilesAll(): Promise<void> {
		const profiles = await this.restService.getter('profile-user', '', '').toPromise() as Array<ProfileUser>;
		const profilesAll: Array<NotificationProfiles> = profiles.map(p => ({
			id: p.id,
			description: p.description,
			active: this.data.profiles.filter(profile => profile === p.id).length > 0
		}));
		this.profilesAll = profilesAll;
	}


	selectActionProfile(p: NotificationProfiles): void {
		let idx = -1;
		idx = this.data.profiles.findIndex((prof) => prof === p.id);
		if (idx >= 0) {
			this.data.profiles.splice(idx, 1);
		} else {
			this.data.profiles.push(p.id);
		}
	}

	isChecked(p: NotificationProfiles, idx: number): boolean {
		console.log(this.isSelect, this.isSelect[idx])
		return this.isSelect[idx]
	}

	close(): void {
		this.saveService.saving = false;
		this.bsModalRef.hide();
	}

	async save(): Promise<void> {
		try {
		const notify = this.formGroup.getRawValue()

		const response = await this.restService.post('popup-notification', '', {
			body: notify.body,
			profiles: notify.profiles.value,
			title: notify.title
		}).toPromise();

		this.alertService.success('Salvo com sucesso!');
		this.formGroup.reset();
		this.success(response, StatusResultModalEdit.SAVE);
		this.close();
	} finally {
		this.authService.saving = false;
	}
	}
}

export interface NotificationProfiles {
	id: string;
	description: string;
	active: boolean;
}
